export const STUDENT_FEEDBACK_LIMIT = 480
export const INSTRUCTIONS_LIMIT = 25000
